import { MapboxOverlay, type MapboxOverlayProps } from '@deck.gl/mapbox';
import { useEffect } from 'react';
import { useControl } from 'react-map-gl/mapbox';

const DeckGLOverlay = (props: MapboxOverlayProps) => {
  const overlay = useControl<MapboxOverlay>(() => new MapboxOverlay(props));

  useEffect(() => {
    overlay.setProps(props);
  }, [props, overlay]);

  return null;
};

export default DeckGLOverlay;
